import React from 'react';
import SearchProducts from './SearchProducts';
import SearchListing from './searchListingComponent/SearchListing';

export const RenderSearchResults = ({searchResults,onPageChange,productList,listingHeader,currentPage,setCurrentPage}) => {


    return (
        <React.Fragment>
            {(searchResults.length <= 1 || window.location.href.indexOf('search-support') === -1) && <SearchProducts productList={productList} />}
            
            {<SearchListing searchResults={searchResults} onPageChange={onPageChange} listingHeader={listingHeader} currentPage={currentPage} setCurrentPage={setCurrentPage} />}
        </React.Fragment>
    );
}

export default RenderSearchResults;